import { ApplicationRef } from '@angular/core';
import { BaseSecurityPageModule } from 'SecuritiesApp/ts/apps/base-security-page/app.module';
import { HoldingsHistoryModule } from 'SecuritiesApp/ts/features/holdings-history/holdings-history.module';
import { TopBarNavComponent } from 'Angular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'Angular/features/components/side-menu/side-menu.component';
import { HoldingsHistoryComponent } from 'SecuritiesApp/ts/features/holdings-history/holdings-history.component';
import { SecurityHeaderControlComponent } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.component';
import { StoreDevtoolsModule } from 'Angular/state/store-devtools/store-devtools.development';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store-devtools";
export class MutualFundsHoldingsHistoryModule {
    ngDoBootstrap(appRef) {
        appRef.bootstrap(HoldingsHistoryComponent);
        appRef.bootstrap(SideMenuComponent);
        appRef.bootstrap(SecurityHeaderControlComponent);
        appRef.bootstrap(TopBarNavComponent);
    }
}
MutualFundsHoldingsHistoryModule.ɵfac = function MutualFundsHoldingsHistoryModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MutualFundsHoldingsHistoryModule)(); };
MutualFundsHoldingsHistoryModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MutualFundsHoldingsHistoryModule });
MutualFundsHoldingsHistoryModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BaseSecurityPageModule, HoldingsHistoryModule, StoreDevtoolsModule] });
